import { Flex, Skeleton } from 'antd';
import { useGetManyInvoicesByEntity } from 'api/invoices/use-get-many-invoices-by-entity.ts';
import { useGetOrder } from 'api/orders/use-get-order.ts';
import { useGetTrip } from 'api/trips/use-get-trip.ts';
import { useGetWarehouseTask } from 'api/warehouse-task/use-get-warehouse-task';
import { ECurrency } from 'types/currencies';
import { InvoiceCreate } from 'components/invoices/invoice-create';
import type { IInvoiceFormFields } from 'components/invoices/invoice-form';
import { InvoicesList } from 'components/invoices/invoices-list';
import type { IInvoicesListWithCreateButtonProps } from './types';

export const InvoicesListWithCreateButton = (props: IInvoicesListWithCreateButtonProps) => {
  const { orderId, tripId, whTaskId, withoutCreateButton = false } = props;

  // временный фикс https://logistic.atlassian.net/browse/LCR-355
  // const { limit, page, handlePageChange } = useStatePagination({ defaultLimit: 50 });
  const {
    data: invoices,
    isLoading,
    isPreviousData,
  } = useGetManyInvoicesByEntity({ page: 1, limit: 50, orderId, tripId, whTaskId });
  const { data: order, isFetching: isFetchingOrder } = useGetOrder(orderId);
  const { data: trip, isFetching: isFetchingTrip } = useGetTrip(tripId);
  const { data: whTask, isFetching: isFetchingWhTask } = useGetWarehouseTask(whTaskId);

  const isInvoiceWithOrder = !!orderId;

  const isLoadingEntity = isFetchingOrder ?? isFetchingTrip ?? isFetchingWhTask;

  const withMain = Boolean(invoices?.data?.find((item) => item.main));

  const invoiceWithOrderInitialPrice = (order?.freight ?? 0) + (order?.documentPrice ?? 0) + (order?.fine ?? 0);

  let price = 0;
  if (isInvoiceWithOrder) {
    price = invoiceWithOrderInitialPrice;
  } else if (trip) {
    price = trip.costPrice;
  } else if (whTask) {
    price = whTask.freight;
  }

  const initialValues: IInvoiceFormFields = {
    currency: order?.currency || trip?.currency || whTask?.currency || ECurrency.EUR,
    price,
    vat: 0,
  };

  return (
    <Flex gap='middle' vertical>
      <Skeleton loading={isLoading}>
        {!withoutCreateButton && (
          <Flex gap='small' align='center' justify='space-between'>
            <div style={{ color: 'var(--gray-text)', fontSize: '.85rem' }}>
              {orderId
                ? 'Main invoice will be created automatically when order gets status "delivered", but you can create it earlier.'
                : null}
            </div>
            <Flex gap='small' align='center'>
              <InvoiceCreate
                orderId={orderId}
                tripId={tripId}
                whTaskId={whTaskId}
                initialValues={initialValues}
                isLoadingData={isLoadingEntity}
              />
              {!withMain && (
                <InvoiceCreate
                  orderId={orderId}
                  tripId={tripId}
                  whTaskId={whTaskId}
                  initialValues={initialValues}
                  isLoadingData={isLoadingEntity}
                  isMain
                />
              )}
            </Flex>
          </Flex>
        )}
        <InvoicesList invoices={invoices?.data || []} isLoading={isPreviousData} withoutClient />
      </Skeleton>
      {/* временный фикс https://logistic.atlassian.net/browse/LCR-355 */}
      {/*<Pagination total={invoices?.pagination?.total} page={page} limit={limit} onChange={handlePageChange} />*/}
    </Flex>
  );
};
